<template>
  <div v-if="value === '-'" class="second-text">{{ value }}</div>
  <div
    v-else-if="value.name"
    class="d-flex align-center align-content-left py-1 pl-0 pl-sm-0"
    :class="{ 'pl-md-6': $route.path === '/dashboard-analytics' }"
  >
    <span
      class="symbol symbol-25 symbol-sm-35 symbol-light-success overflow-hidden mr-3"
    >
      <img
        style="border-radius: 50% !important"
        v-if="value?.photo?.url"
        alt="photo"
        :src="value.photo.url"
      />
      <span
        v-else
        style="border-radius: 50% !important"
        class="symbol-label font-size-base font-size-h5-sm"
        :class="getRandomColors()"
      >
        {{ value.name[0].toUpperCase() }}
      </span>
    </span>

    <v-tooltip v-if="isOrdersModule" top content-class="client-name-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="first-text text-capitalize" v-bind="attrs" v-on="on">
          {{ truncatedName }}
        </span>
      </template>
      <span>{{ value.name }}</span>
    </v-tooltip>
    <span v-else class="first-text text-capitalize">
      {{ value.name }}
    </span>
  </div>
  <div v-else class="second-text">{{ value }}</div>
</template>

<script>
/**
    Component for displaying client  name with photo
    api type name : clientPhoto
*/
export default {
  name: "ClientColumn",
  props: ["value"],
  data: () => ({
    bgColors: [
      "bg-light-success text-success",
      "bg-light-danger text-danger",
      "bg-light-info text-info",
      "bg-light-primary text-primary",
      "bg-light-warning text-warning",
      "bg-light-dark text-dark",
    ],
  }),
  computed: {
    // Orders is the only module that wants the truncated name + hover
    // tooltip; everywhere else should render as it did before that change.
    // Route-based rather than store-based: stale Vuex state from a prior
    // visit to Orders would otherwise leak the truncation into other pages.
    isOrdersModule() {
      return this.$route.name === "fulfillment.orders";
    },
    truncatedName() {
      const name = this.value.name;
      return name.length > 15 ? `${name.slice(0, 15)}...` : name;
    },
  },
  methods: {
    getRandomColors: function () {
      return this.bgColors[Math.floor(Math.random() * this.bgColors.length)];
    },
  },
};
</script>

<style scoped>
.first-text {
  display: inline-block;
  vertical-align: middle;
  cursor: default;
}
</style>

<style>
.client-name-tooltip.v-tooltip__content {
  background: #212529 !important;
  color: #fff !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  padding: 6px 12px !important;
  border-radius: 6px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25) !important;
  opacity: 1 !important;
}
</style>
